import { useContext } from 'react';
import * as R from 'ramda';

import ReplaceElementModalContext, {
  ModalStep,
} from '@atom/components/common/replaceElement/ReplaceElementModalContext';
import { Stepper } from '@atom/mui';

import classes from './replaceElement.module.css';

const { StepLabel, Step } = Stepper;

const StepperSidebar = () => {
  const {
    activeStep,
    STEPS_ARRAY,
    element,
    replacementAsset,
    replacementAssetPath,
    destinationAsset,
    destinationAssetPath,
  } = useContext(ReplaceElementModalContext);

  const activeStepIndex = R.findIndex(R.propEq(activeStep, 'value'))(
    STEPS_ARRAY,
  );

  const getStepDisplay = (step: ModalStep): { title: any; subtext: any } => {
    const rootAssetName = R.head(element?.ancestors || [])?.name;
    const replacementAssetDisplay = R.dropLast(
      1,
      replacementAssetPath.map(item => item.name),
    ).join(' / ');
    const destinationPathDisplay = destinationAssetPath
      .map(item => item.name)
      .join(' / ');

    switch (step) {
      case ModalStep.ELEMENT: {
        return {
          title: `Replace: ${element?.name}`,
          subtext: `On: ${rootAssetName}`,
        };
      }
      case ModalStep.REPLACE: {
        return {
          title: R.isNil(replacementAsset)
            ? 'Select Replacement'
            : `With: ${replacementAsset?.name}`,
          subtext: R.isNil(replacementAsset)
            ? 'Choose an item to replace with'
            : `From: ${replacementAssetDisplay}`,
        };
      }
      case ModalStep.DESTINATION: {
        return {
          title: R.isNil(destinationAsset)
            ? 'Move Existing Sub Item'
            : `Move: ${element?.name}`,
          subtext: R.isNil(destinationAsset)
            ? 'Choose destination for existing item'
            : `To: ${destinationPathDisplay}`,
        };
      }
      case ModalStep.CONFIRM: {
        return { title: 'Confirm', subtext: '' };
      }
      default: {
        return { title: '', subtext: '' };
      }
    }
  };

  return (
    <div className={classes.stepperContainer}>
      <Stepper activeStep={activeStepIndex} orientation="vertical">
        {STEPS_ARRAY.map(step => {
          const display = getStepDisplay(step.value);

          return (
            <Step key={display.title}>
              <StepLabel error={false}>
                <>
                  <div>{display.title}</div>
                  {display.subtext && (
                    <div className={classes.stepSubtext}>{display.subtext}</div>
                  )}
                </>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};

export default StepperSidebar;
